export enum OrganizationStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const ORGANIZATION_STATUS_LABELS: Record<OrganizationStatus, string> = {
  [OrganizationStatus.ACTIVE]: 'Active',
  [OrganizationStatus.INACTIVE]: 'Inactive',
};

export const ORGANIZATION_STATUS_ORDER: readonly OrganizationStatus[] = [
  OrganizationStatus.ACTIVE,
  OrganizationStatus.INACTIVE,
];
